/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Page_Meta_TitleInputs */

const en_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | Put your capital where it belongs`)
};

const de_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | Setzen Sie Ihr Kapital dort ein, wo es hingehört`)
};

const pt_br2_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | Coloque seu capital onde ele pertence`)
};

const tr_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | Sermayenizi ait olduğu yere koyun`)
};

const zh_cn2_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | 让资本配置到它应在的地方`)
};

const zh_hk2_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | 將你的資本配置到應在的地方`)
};

const ko_kr2_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | 자본이 있어야 할 곳에 투자하세요`)
};

const ru_ru2_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | Разместите капитал там, где ему место`)
};

const es_419_landing_page_meta_title = /** @type {(inputs: Landing_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider | Pon tu capital donde corresponde`)
};

/**
* | output |
* | --- |
* | "Glider \| Put your capital where it belongs" |
*
* @param {Landing_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const landing_page_meta_title = /** @type {((inputs?: Landing_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_page_meta_title(inputs)
	if (locale === "de") return de_landing_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_landing_page_meta_title(inputs)
	if (locale === "tr") return tr_landing_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_landing_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_landing_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_landing_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_landing_page_meta_title(inputs)
	return es_419_landing_page_meta_title(inputs)
});